<style>
	.edi-sendinfo-title{
		height: 143px;
		line-height: 143px;
		text-align: center;
		letter-spacing: 1px;
		font-weight: bold;
	}
</style>
<template>
<div class="edi-info" :style="{ 'height': deviceHeight }">
	<div class="edi-sendinfo-title">送货信息维护</div>
	<ul class="ui-listview">
		<li>
			<span class="ui-col-3">送货人</span>
			<input type="text" class="ui-col-7" v-model="name" />
		</li>
		<li>
			<span class="ui-col-3">手机号</span>
			<input type="text" class="ui-col-7" v-model="phone" />
		</li>
		<li>
			<span class="ui-col-3">车牌号</span>
			<input type="text" class="ui-col-7" v-model="carNum" />
		</li>
	</ul>
	<fieldset class="ui-controlgroup" style="padding: 0 .5em">
		<input type="submit" value="保存修改" class="submit" @click="modifySave" />
	</fieldset>
	<tips-auto v-show="tipsauto" :tipsFont = "tipsFont"></tips-auto>
	<loading v-show="loading"></loading>
	<div class="tips-mask-t" v-show="tipsTwoShow" @click.stop="hideRuturnConfirm">
		<div class="tips-wrapper" :class="{'tips-start':tipsTwoShow,'tips-end':!tipsTwoShow}">
			<div class="tips-font">
				<p>{{elseTipsFont}}</p>
			</div> 
			<div class="tips-btns">
				<a class="tips-two-btn tips-marbot red-font" @click.stop="saveReturn">{{elseBtnFont[0]}}</a> 
				<a class="tips-two-btn tips-marbot" @click.stop="quitRuturn">{{elseBtnFont[1]}}</a>
				<a class="tips-two-btn" @click.stop="hideRuturnConfirm">{{elseBtnFont[2]}}</a>
			</div>
		</div>
	</div>
</div>
</template>
<!--{{{ script -->
<script>
import TipsAuto from '../components/TipsAuto'
import Loading from '../components/loading'
export default {
	data () {
		return {
			skipRoute: false,
			tipsauto: false,
			isChange: false,
			isReturn: false,
			loading: false,
			tipsFont: '',
			sec: 1500,
			deviceHeight: this.$root.deviceHeight,
			transitionName: 'page-next',
			companyInfo: {},
			name: '',
			phone: '',
			carNum: '',
			tipsTwoShow: false,
			elseTipsFont: '当前送货信息尚未保存',
			elseBtnFont: ['保存并返回', '放弃并返回', '取消'],
			chinesePatrn: /^[\u2E80-\u9FFF]+$/
		}
	},
	components: {
		'tips-auto': TipsAuto,
		'loading': Loading
	},
	beforeRouteLeave (to, from, next) {
		if (this.skipRoute) {
			next()
			return
		}
		if (this.isChange) {
			next(false)
			this.tipsTwoShow = true
		} else {
			next()
		}
	},
	created () {
		this.loading = true
		this.$http.post('/cldEdi/business/getSendSysUser').then(response => {
			this.loading = false
			var data = response.body
			if (data.result) {
				this.companyInfo = response.body.data
				this.name = this.companyInfo.sender
				this.phone = this.companyInfo.senderPhone
				this.carNum = this.companyInfo.plateNumber
			} else {
				this.autoTips(data.message)
				return
			}
		}, (response) => {
			this.loading = false
			this.autoTips('服务中断，稍后请重试！')
			return
		})
	},
	methods: {
		autoTips (msg) {
			var self = this
			self.tipsauto = true
			self.tipsFont = msg
			setTimeout(() => {
				self.tipsauto = false
			}, self.sec)
		},
		modifySave () {
			// 送货信息是可以为空的
			// if (this.name === '') {
			// 	this.autoTips('送货人不能为空')
			// 	return false
			// }
			// if (this.phone === '') {
			// 	this.autoTips('手机号不能为空')
			// 	return false
			// }
			// if (this.carNum === '') {
			// 	this.autoTips('车牌号不能为空')
			// 	return false
			// }
			// 对接保存送货信息接口
			this.isChange = false
			var obj = {
				sender: this.name,
				senderPhone: this.phone,
				plateNumber: this.carNum
			}
			var self = this
			this.loading = true
			this.isReturn = true
			this.$http.post('/cldEdi/business/updateSendSysUser', obj).then(response => {
				this.loading = false
				var data = response.body
				if (!data.result) {
					this.autoTips(data.message)
					return false
				} else {
					this.loading = false
					this.autoTips('修改成功')
					if (this.isReturn) {
						setTimeout(() => {
							this.$router.replace('/main/my')
						}, self.sec)
					}
				}
			}, (response) => {
				this.loading = false
				this.autoTips('服务中断，稍后请重试！')
				return
			})
		},
		saveReturn () {
			this.tipsTwoShow = false
			this.isReturn = true
			// 保存再返回
			this.modifySave()
		},
		quitRuturn () {
			this.isChange = false
			this.tipsTwoShow = false
			this.$router.replace({path: '/main/my'})
		},
		hideRuturnConfirm () {
			this.isChange = true
			var route = this.$route
			var path = route.path
			var query = route.query
			this.tipsTwoShow = false
			this.skipRoute = true
			this.$router.replace('/main/my')
			this.$router.push({
				path: path,
				query: query
			})
			this.skipRoute = false
		}
	},
	watch: {
		carNum (newVal, oldVal) {
			if (oldVal === '') {
				this.isChange = false
			} else {
				this.isChange = true
			}
		},
		name (newVal, oldVal) {
			if (oldVal === '') {
				this.isChange = false
			} else {
				this.isChange = true
			}
		},
		phone (newVal, oldVal) {
			if (oldVal === '') {
				this.isChange = false
			} else {
				this.isChange = true
			}
		}
	}
}
</script>
<!--}}}-->



// WEBPACK FOOTER //
// SendInfo.vue?b92058b0